document.addEventListener('DOMContentLoaded', function () {
  initTableOfContents();
  initBlogFaqAccordion();
  initStickySidebar();
});

/* ===========================
   BLOG TABLE OF CONTENTS
=========================== */

function initTableOfContents() {
  const content = document.getElementById('BlogContent');
  const toc = document.getElementById('BlogTOC');

  if (!content || !toc) return;

  const headings = Array.from(content.querySelectorAll('h2'));

  /* Prevent duplicate TOC items */
  toc.innerHTML = '';

  if (!headings.length) {
    toc.innerHTML = '<p>No sections available</p>';
    return;
  }

  const list = document.createElement('ul');

  headings.forEach(function (heading, index) {
    if (!heading.id) {
      heading.id = 'section-' + (index + 1);
    }

    const li = document.createElement('li');
    li.className = heading.tagName.toLowerCase();

    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;

    li.appendChild(link);
    list.appendChild(li);
  });

  toc.appendChild(list);

  const linksById = new Map(
    Array.from(toc.querySelectorAll('a')).map(function (link) {
      return [
        link.getAttribute('href').slice(1),
        link
      ];
    })
  );

  function setActive(id) {
    linksById.forEach(function (link, linkId) {
      link.classList.toggle('active', linkId === id);
    });
  }

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(entry.target.id);
        }
      });
    },
    {
      rootMargin: '-150px 0px -70% 0px',
      threshold: 0
    }
  );

  headings.forEach(function (heading) {
    observer.observe(heading);
  });
}

/* ===========================
   STICKY SIDEBAR OFFSET
=========================== */

function initStickySidebar() {
  const header = document.querySelector('.header-wrapper');
  const gap = 24;

  function setOffset() {
    const headerHeight = header ? header.offsetHeight : 80;

    document.documentElement.style.setProperty(
      '--article-sticky-offset',
      headerHeight + gap + 'px'
    );
  }

  setOffset();

  if (header && 'ResizeObserver' in window) {
    const headerObserver = new ResizeObserver(setOffset);
    headerObserver.observe(header);
  } else {
    window.addEventListener('resize', setOffset, {
      passive: true
    });
  }
}

/* Shopify Theme Editor support */
document.addEventListener('shopify:section:load', function () {
  initTableOfContents();
  initBlogFaqAccordion();
  initStickySidebar();
});

/* ===========================
   BLOG FAQ ACCORDION
=========================== */

const BLOG_FAQ_END_HEADINGS = new Set([
  'conclusion',
  'final thoughts',
  'final takeaway',
  'key takeaway',
  'key takeaways',
  'shop the collection',
  'explore our collection'
]);

function normalizeBlogHeading(element) {
  return element.textContent
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/[.!?:]+$/g, '');
}

/*
 * Checks whether an H3 is a conclusion or CTA heading
 * that should remain outside the accordion.
 */
function isBlogFaqEndHeading(element) {
  if (!element || element.tagName !== 'H3') return false;

  /*
   * Custom CTA example:
   * <h3 class="nse-blog-faq-end">Find Your Perfect Eyeglasses</h3>
   */
  if (element.classList.contains('nse-blog-faq-end')) {
    return true;
  }

  return BLOG_FAQ_END_HEADINGS.has(
    normalizeBlogHeading(element)
  );
}

/*
 * Converts H3 questions under the Frequently Asked Questions
 * H2 heading into native accessible accordions.
 */
function initBlogFaqAccordion() {
  const content = document.getElementById('BlogContent');

  if (!content) return;

  const headings = Array.from(
    content.querySelectorAll('h2')
  );

  const faqHeadings = headings.filter(function (heading) {
    const text = normalizeBlogHeading(heading);

    return (
      text === 'faq' ||
      text === 'faqs' ||
      text.startsWith('frequently asked question')
    );
  });

  faqHeadings.forEach(function (faqHeading) {
    /*
     * Prevent duplicate transformation.
     */
    if (faqHeading.dataset.nseFaqReady === 'true') return;

    const faqNodes = [];
    let node = faqHeading.nextElementSibling;

    /*
     * FAQ section ends when:
     * 1. The next H2 starts
     * 2. A recognised conclusion H3 appears
     * 3. An H3 with class nse-blog-faq-end appears
     */
    while (
      node &&
      node.tagName !== 'H2' &&
      !isBlogFaqEndHeading(node)
    ) {
      faqNodes.push(node);
      node = node.nextElementSibling;
    }

    const firstQuestion = faqNodes.find(function (element) {
      return element.tagName === 'H3';
    });

    /*
     * Do nothing when the FAQ H2 has no H3 questions.
     */
    if (!firstQuestion) return;

    const faqList = document.createElement('div');
    faqList.className = 'nse-blog-faq__list';

    /*
     * Any introductory paragraph between the FAQ H2
     * and first question remains above the accordion.
     */
    firstQuestion.before(faqList);

    let currentAnswer = null;

    faqNodes.forEach(function (element) {
      if (element.tagName === 'H3') {
        const details = document.createElement('details');
        details.className = 'nse-blog-faq__item';

        const summary = document.createElement('summary');
        summary.className = 'nse-blog-faq__question';

        /*
         * Preserve the original H3, text, ID and links.
         */
        element.classList.add(
          'nse-blog-faq__question-title'
        );

        const icon = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg'
        );

        icon.setAttribute(
          'class',
          'nse-blog-faq__icon'
        );
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('fill', 'none');
        icon.setAttribute('stroke', 'currentColor');
        icon.setAttribute('stroke-width', '2');
        icon.setAttribute('stroke-linecap', 'round');
        icon.setAttribute('stroke-linejoin', 'round');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');

        const path = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'path'
        );

        path.setAttribute('d', 'M6 9l6 6 6-6');

        icon.appendChild(path);
        summary.appendChild(element);
        summary.appendChild(icon);

        currentAnswer = document.createElement('div');
        currentAnswer.className =
          'nse-blog-faq__answer rte';

        details.appendChild(summary);
        details.appendChild(currentAnswer);
        faqList.appendChild(details);
      } else if (currentAnswer) {
        /*
         * Content after a question becomes its answer
         * until the next H3 question.
         */
        currentAnswer.appendChild(element);
      }
    });

    if (!faqList.children.length) {
      faqList.remove();
      return;
    }

    const eyebrow = document.createElement('p');
    eyebrow.className = 'nse-blog-faq__eyebrow';
    eyebrow.textContent = 'GOOD TO KNOW';

    faqHeading.before(eyebrow);
    faqHeading.classList.add(
      'nse-blog-faq__heading'
    );
    faqHeading.dataset.nseFaqReady = 'true';
  });
}